<section class="content">
  <div class="card" style="padding:25px">
  <div class="container">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" [min]="from_date" />
      </div>
      <div class="col-1"></div>
      <div class="col">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 4%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="to_date == null || from_date == null">Get</button>
      </div>
    </div>
    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row">
      <div class="col">
        <table class="table table-bordered table-hover" id="printTable" *ngIf="payment_log_data.length !== 0">
          <thead style="background: bisque;">
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Booth / Customer Code<input matInput type="text" #code_filter placeholder="b/c code"
                  style="border: 2px solid #ff7b7b;border-radius: 12px;margin-top: 10px;text-indent:10px"></th>
              <th>Amount</th>
              <th>Requested Time</th>
              <th>Requested For</th>
              <th>Responce Status</th>
              <th>Responce Time</th>
              <th>Enquiry Status</th>
              <th>Enquiry Time</th>
              <th>Is Wallet Used</th>
              <th>RID</th>
              <th>CRN</th>
              <th>Transaction Number</th>
              <th>Transacted Time</th>
              <th>BRN</th>
              <th>Payment Mode</th>
              <th>Enquiry</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let payment_log of payment_log_data | globalSearch:'booth_or_customer_code': code_filter.value; let payment_log_index=index ">
              <td
                [style.border-left]="checkBorderColor(payment_log['responce_status_name'], payment_log['enquiry_response_status_latest'])">
                {{ payment_log_index + 1 }}</td>
              <td>{{ payment_log['first_name']}} {{payment_log['last_name']}}</td>
              <td>{{ payment_log['booth_or_customer_code']}}</td>
              <td>{{ payment_log['amt'] | currency: 'INR'}}</td>
              <td style="font-size: 12px;">{{ payment_log['request_time_created'] | date: 'dd-MM-yyyy, h:mm a'}}</td>
              <td>{{ payment_log['payment_request_for']}}</td>
              <td *ngIf="payment_log.responce_status_name !== 0" style="background: #f7f7eb; font-weight: bold;">
                {{ payment_log['responce_status_name']}}</td>
              <td *ngIf="payment_log.responce_status_name == 0" style="background: #f7f7eb; font-weight: bold;">-</td>
              <td *ngIf="payment_log.responce_status_name !== 0" style="font-size: 12px;">
                {{ payment_log['responce_time_created'] | date: 'dd-MM-yyyy, h:mm a'}}</td>
              <td *ngIf="payment_log.responce_status_name == 0">-</td>
              <td *ngIf="payment_log.enquiry_response_status_latest !== 0"
                style="background: #f7f7eb; font-weight: bold;">
                {{ payment_log['enquiry_response_status_latest']}}</td>
              <td *ngIf="payment_log.enquiry_response_status_latest == 0"
                style="background: #f7f7eb; font-weight: bold;">-</td>
              <td *ngIf="payment_log.latest_enquiryed_time !== 0" style="font-size: 12px;">
                {{ payment_log['latest_enquiryed_time'] | date: 'dd-MM-yyyy, h:mm a'}}</td>
              <td *ngIf="payment_log.is_wallet_selected">Yes</td>
              <td *ngIf="!payment_log.is_wallet_selected">No</td>
              <td>{{ payment_log['rid']}}</td>
              <td>{{ payment_log['crn']}}</td>
              <td *ngIf="payment_log.responce_status_name !== 0">{{ payment_log['trn']}}</td>
              <td *ngIf="payment_log.responce_status_name == 0">-</td>
              <td *ngIf="payment_log.responce_status_name !== 0" style="font-size: 12px;">{{ payment_log['tet'] | date: 'dd-MM-yyyy, h:mm a'}}</td>
              <td *ngIf="payment_log.responce_status_name == 0">-</td>
              <td *ngIf="payment_log.responce_status_name !== 0">{{ payment_log['brn']}}</td>
              <td *ngIf="payment_log.responce_status_name == 0">-</td>
              <td *ngIf="payment_log.responce_status_name !== 0">{{ payment_log['pmd']}}</td>
              <td *ngIf="payment_log.responce_status_name == 0">-</td>
              <td><button mat-button style="background: green;color: white;"
                  (click)="enqiryCalled(payment_log['rid'])">Enquiry</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  </div>
</section>
